import React from "react";
import { CollectionPreferences } from "@amzn/awsui-components-react-v3";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../common/redux/store/store";
import { UPDATE_PREFERENCES } from "../../../../common/redux/types/configureRackBOMOverrideTypes";

const CONTENT_DISPLAY_OPTIONS = [
  {
    label: 'Primary columns',
    options: [
      {id: "category", label: "Category", alwaysVisible: true},
      {id: "ipn", label: "Component IPN", alwaysVisible: true},
      {id: "externalRackType", label: "External Rack Type"},
      {id: "internalRackType", label: "Internal Rack Type"},
      {id: "rackIPN", label: "Rack IPN"},
      {id: "status", label: "Status"},
      // {id: "department", label: "Department"}, (will enable once backend is ready)
    ]
  }
]

export const DEFAULT_PREFERENCES = {
  stickyColumns: {first: 0, last: 0},
  visibleContent: ['category', 'ipn', 'externalRackType', 'internalRackType', 'rackIPN', 'status', 'department']
};

export const PreferencesComponent = ({disabled, visibleContentOptions = CONTENT_DISPLAY_OPTIONS}) => {
  const dispatch = useDispatch<AppDispatch>();
    const {preferences} = useSelector((state: RootState) => state.configureRackBOMOverrideDetails);
    return (
        <CollectionPreferences
        title="Preferences"
        confirmLabel="Confirm"
        cancelLabel="Cancel"
        disabled={disabled}
        onConfirm={({detail}) => dispatch({type: UPDATE_PREFERENCES, payload: detail})}
        preferences={preferences}
        visibleContentPreference={{
          title: 'Column Preferences',
          options: visibleContentOptions,
      }}
        stickyColumnsPreference={{
          firstColumns: {
            title: "Stick first column(s)",
            description:
              "Keep the first column(s) visible while horizontally scrolling the table content.",
            options: [
              { label: "None", value: 0 },
              { label: "First column", value: 1 },
              { label: "First two columns", value: 2 }
            ]
            },
          lastColumns: {
            title: "Stick last column",
            description:
              "Keep the last column visible while horizontally scrolling the table content.",
            options: [
              { label: "None", value: 0 },
              { label: "Last column", value: 1 }
            ]
          }
        }}
        />
    );
}